"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ZIndex;

(function (ZIndex) {
  ZIndex[ZIndex["highPriorityModal"] = 101] = "highPriorityModal";
  ZIndex[ZIndex["normalPriorityModal"] = 100] = "normalPriorityModal";
  ZIndex[ZIndex["overlay"] = 100] = "overlay";
  ZIndex[ZIndex["transparentOverlay"] = 5] = "transparentOverlay";
  ZIndex[ZIndex["bottomBar"] = 4] = "bottomBar";
  ZIndex[ZIndex["headerFooter"] = 2000] = "headerFooter";
  ZIndex[ZIndex["dropdown"] = 2] = "dropdown";
  ZIndex[ZIndex["local"] = 1] = "local";
  ZIndex[ZIndex["normal"] = 0] = "normal";
  ZIndex[ZIndex["loadingBar"] = 1021] = "loadingBar";
  ZIndex[ZIndex["carouselArrow"] = 1] = "carouselArrow";
  ZIndex[ZIndex["nav"] = 3] = "nav";
  ZIndex[ZIndex["navMenu"] = 2] = "navMenu";
  ZIndex[ZIndex["navOverlay"] = 1] = "navOverlay";
})(ZIndex || (ZIndex = {}));

exports.default = ZIndex;